import { CreateStandingOfferPage } from "@/features/subscriptions";
import { requireAdmin } from "@/lib/tanstack-router/requireAdmin";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/create-standing-offer"
)({
  component: requireAdmin(CreateStandingOffer)
});

function CreateStandingOffer() {
  return <CreateStandingOfferPage />;
}
